import React from 'react'
import { Carousel } from 'react-responsive-carousel'

// ----------------------------------------------------------------------
const indicatorStyles = {
  background: 'var(--primary-color)',
  width: 14,
  height: 14,
  display: 'inline-block',
  margin: '0 1.3rem',
  borderRadius: '50%',
  opacity: 0.37,
  cursor: 'pointer',
}

const renderIndicator = (onClickHandler, isSelected, index, label) => {
  if (isSelected) {
    return (
      <li
        style={{ ...indicatorStyles, opacity: 1 }}
        aria-label={`Selected: ${label} ${index + 1}`}
        title={`Selected: ${label} ${index + 1}`}
      />
    )
  }
  return (
    <li
      style={indicatorStyles}
      onClick={onClickHandler}
      onKeyDown={onClickHandler}
      value={index}
      key={index}
      role='button'
      tabIndex={0}
      title={`${label} ${index + 1}`}
      aria-label={`${label} ${index + 1}`}
    />
  )
}

const CarouselItem = ({ title, description, imageSrc }) => {
  return (
    <div className='root'>
      <div className='hero-container'>
        <div className='hero-title'>{title}</div>
        <div className='hero-image'>
          <img src={imageSrc} alt={description} />
        </div>
        <div className='hero-description'>
          <p>{description}</p>
        </div>
      </div>

      <style jsx>{`
        .root {
          display: flex;
          justify-content: center;

          .hero-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 4.1rem 0;

            .hero-image {
              height: 100%;
              width: 100%;
              max-width: 120.5rem;
              max-height: 71.8rem;
            }

            .hero-title {
              padding: 1.9rem 1.5rem;
              line-height: 2.8rem;
              font-size: 2.4rem;
            }

            .hero-description {
              padding: 1.9rem 1.5rem;
              font-size: 2.2rem;
              margin-bottom: 2rem;
              line-height: 1.4;
              max-width: 120.5rem;
            }
          }
        }

        @media (max-width: 1024px) {
          .root {
            .hero-container {
              margin: 2.1rem 0;

              .hero-image {
                height: 100%;
                width: 100%;
                max-width: 120.5rem;
                max-height: 71.8rem;
              }

              .hero-title {
                font-size: 1.6rem;
              }

              .hero-description {
                padding: 1.9rem 1.5rem;
                font-size: 1.4rem;
                margin-bottom: 2rem;
              }
            }
          }
        }
      `}</style>
    </div>
  )
}
// ----------------------------------------------------------------------

export default function ConciergeProcess() {
  return (
    <div className='root'>
      <h2 className='title'>Our Concierge Process</h2>

      <div className='slider'>
        <Carousel
          autoPlay
          infiniteLoop
          showArrows={false}
          showStatus={false}
          renderIndicator={renderIndicator}
          showThumbs={false}
          interval={5000}
        >
          <CarouselItem
            title='Help find the vehicle you want'
            description='Our Concierge Team can assist you find the perfect vehicle for you. From understanding your needs to walking you through our search and buying process we are committed to ensuring you get just the right car for you!'
            imageSrc='/images/buy/concierge/find-vehicle.jpg'
          />
          <CarouselItem
            title='Discuss financing options'
            description="We can provide financing options should you need it and our Concierge Team are ready to assist you. We will review the different rates and terms and work with you to find the monthly amount that fits your budget. We'll then connect you to our Financing Team who will clearly explain and guide you through the rest of the financing process. Our goal is to ensure you get the car you want at the price you can afford with nothing hidden in the small print."
            imageSrc='/images/buy/concierge/assist-financing.jpg'
          />
          <CarouselItem
            title='Protect your purchase and aid with delivery'
            description="Once you've found and purchased your vehicle our Concierge Team will work with you to get your vehicle delivered or dropped off at the closest location to you. Our drop off locations are well-lit, secure and manned, with knowledgeable staff on hand to assist in the transfer of ownership to you. Our Concierge Team will walk you through all of the warranty and protection options that we offer to protect your purchase. No pressure, just great options. *additional charges for vehicle delivery may apply*"
            imageSrc='/images/buy/concierge/aid-delivery.jpg'
          />
        </Carousel>
      </div>

      <style jsx>{`
        .root {
          padding: 11.2rem 3.3rem;
          .title {
            text-align: center;
            line-height: 5.1rem;
            font-size: 5.4rem;
          }
        }

        @media (max-width: 1024px) {
          .root {
            padding: 5rem 3rem;

            .title {
              line-height: 2.6rem;
              font-size: 2rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
